export const msalConfig = {
  auth: {
    clientId: "d3cccf70-30d9-450e-9a77-0bdda35f8922",
    authority:
      "https://login.microsoftonline.com/2e650851-8649-457e-a18a-bc0264c3b7d0",
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
 };
  
 // Add scopes here for ID token to be used at Microsoft identity platform endpoints.
 export const loginRequest = {
  scopes: ["User.Read"],
 };
  
 export const tokenRequest = {
  scopes: ["api://d3cccf70-30d9-450e-9a77-0bdda35f8922/All"],
 };
 